import i18n from '../../../../../i18n';

export default {
  tokenRemoved: 'لینک دسترسی حذف شد',
  addAccessLink: 'لینک جدید',
  thereIsNoLinksYet: 'هنوز هیچ لینک دسترسی مستقیمی ایجاد نشده است.',

  tokenSavedSuccessfully(isUpdate: boolean) {
    return isUpdate
      ? i18n.t('linkUpdated', { ns: 'survey' })
      : i18n.t('linkCraeted', { ns: 'survey' });
  },
};
